export const datadogConfig = {
  site: "datadoghq.eu",
  service: "fe-nova",
}
